/* eslint-disable */
export default {
  infoMessageMins: 'ログを{delayTime}分後に自動保存します...',
  infoMessageMin: 'ログを{delayTime}分後に自動保存します...',
  infoMessageSecs: 'ログを{delayTime}秒後に自動保存します...',
  infoMessageSec: 'ログを{delayTime}秒後に自動保存します...',
} as const;

// @key: @#@"infoMessageMins"@#@ @source: @#@"Auto-save log in {delayTime} minutes..."@#@
// @key: @#@"infoMessageMin"@#@ @source: @#@"Auto-save log in {delayTime} minute..."@#@
// @key: @#@"infoMessageSecs"@#@ @source: @#@"Auto-save log in {delayTime} seconds..."@#@
// @key: @#@"infoMessageSec"@#@ @source: @#@"Auto-save log in {delayTime} second..."@#@
